module.exports = __webpack_public_path__ + "static/media/DashboardHome.0f235b79.PNG";